/*
 * @Author: zhangwenbangde@163.com
 * @Date: 2019-04-18 15:51:40
 * */
let locaHref,proxyPath,airport,query_page,getAreaList,checkScopeNew,shopList,trainStation,imageProxyPath;

switch (process.env.NODE_ENV) {
  case 'development':
    //locaHref是项目客户访问链接,不是接口链接
    locaHref ='http://192.168.168.82:8696/';
    //这里是本地的请求url/
    proxyPath = "http://paytest.xbserver.com/";
    imageProxyPath = 'http://paytest.xbserver.com/';//图片代理地址
    airport='http://dj.auto1768.cn:8101/h5/org/geographicInformation/query/OR0148/airport';
    query_page='http://192.168.3.17:7777/driving-supplier-service-prd/secondary_supplier/query_page';
    getAreaList='http://192.168.1.143:8853/csp-web-website/webArea/getSourceShopAreaList';
    checkScopeNew='http://sd.ssdlqcfw.com/ShengDaBesPlatform/thirdBes/bespeak/checkScope';
    shopList='http://192.168.1.143:8853/csp-web-website/webShop/shopList';
    trainStation='http://dj.auto1768.cn:8101/h5/org/geographicInformation/query/OR0148/trainStation';

    break
  case 'test':   // 注意这里的名字要和步骤二中设置的环境名字对应起来
  //locaHref是项目客户访问链接,不是接口链接
    locaHref = "http://192.168.168.82:8696/";
    //这里是测试环境中的url
    // proxyPath = "http://192.168.166.24:8800/ShengDaGSNHHD/";//本地接口地址
    proxyPath = "http://paytest.xbserver.com/";//本地接口地址
    imageProxyPath = 'http://paytest.xbserver.com/';//图片代理地址
    airport='http://dj.auto1768.cn:8101/h5/org/geographicInformation/query/OR0148/airport';
    query_page='http://192.168.3.17:7777/driving-supplier-service-prd/secondary_supplier/query_page';
    getAreaList='http://192.168.1.143:8853/csp-web-website/webArea/getSourceShopAreaList';
    checkScopeNew='http://sd.ssdlqcfw.com/ShengDaBesPlatform/thirdBes/bespeak/checkScope';
    shopList='http://192.168.1.143:8853/csp-web-website/webShop/shopList';
    trainStation='http://dj.auto1768.cn:8101/h5/org/geographicInformation/query/OR0148/trainStation';

    break
  case 'production':
  //locaHref是项目客户访问链接,不是接口链接
    locaHref ='http://192.168.168.82:8696/';
     //生产环境url
    proxyPath = 'https://www.schengle.com/';//线上
    imageProxyPath = 'http://paytest.xbserver.com/';//线上
    airport='http://dj.auto1768.cn:8101/h5/org/geographicInformation/query/OR0148/airport';
    query_page='http://192.168.3.17:7777/driving-supplier-service-prd/secondary_supplier/query_page';
    getAreaList='http://csp.schengle.com/csp-web-website/webArea/getSourceShopAreaList';
    checkScopeNew='http://sd.ssdlqcfw.com/ShengDaBesPlatform/thirdBes/bespeak/checkScope';
    shopList='http://csp.schengle.com/csp-web-website/webShop/shopList';
    trainStation='http://dj.auto1768.cn:8101/h5/org/geographicInformation/query/OR0148/trainStation';

    break
}



module.exports={
  locaHref,
  proxyPath,
  imageProxyPath,
  airport,
  query_page,
  getAreaList,
  checkScopeNew,
  shopList,
  trainStation
};
